import React, { useState, useEffect, useRef } from "react";
import {
  markNotificationAsRead, subscribeToNotifications
} from "../../utils/firebaseConfig";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import notificationIcon from "../../assets/img/notification.svg";
import notificationReadIcon from "../../assets/img/notification-r.svg";
import star from "../../assets/img/Logo_MAE_2024.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logoutUser } from "../../store/action/auth";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    dialogTitle: {
      fontFamily: "Poppins",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "22px",
      letterSpacing: "0.5px",
      textAlign: "left",
      marginBottom: theme.spacing(2),
      color: "rgba(73, 75, 105, 1)",
      backgroundColor: "rgba(244, 244, 244, 1)",
    },
    separator: {
      width: "1px",
      backgroundColor: "rgba(229, 234, 238, 1)",
      height: "100%",
      margin: "0 16px",
    },
    notificationBadge: {
      position: "absolute",
      top: "-4px",
      right: "95px",
      backgroundColor: "red",
      color: "white",
      borderRadius: "50%",
      width: "12px",
      height: "12px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "Poppins",
      fontSize: "8px",
      fontWeight: "bold",
      cursor: "pointer",
      transform: "translate(50%, -50%)",
    },
    dropdown: {
      color: "rgba(187, 200, 8, 1)",
      position: "absolute",
      backgroundColor: "white",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      padding: "1rem",
      top: "1.25rem",
      right: "5.75rem",
      borderRadius: "6px",
      zIndex: "1000",
      width: "300px",
      maxHeight: "400px",
      overflowY: "auto",
    },
    dropdownButton: {
      height: "26px",
      borderRadius: "51px",
      background: "transparent",
      padding: "5px 15px",
      fontFamily: "Poppins",
      fontSize: "10.17px",
      fontWeight: 500,
      lineHeight: "15.26px",
      color: "rgba(60, 60, 60, 1)",
      border: "0",
      cursor: "pointer",
      marginRight: "8px",
    },
    notificationItem: {
      padding: "0.5rem",
      marginBottom: "0.5rem",
      borderBottom: "1px solid #E2D9EF",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      position: "relative",
      minHeight: "50px", // Ensures consistent height for each notification item
      flexDirection: "row", // Ensures horizontal layout for icon and text
      overflow: "hidden",
    },
    notificationText: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      flexGrow: 1, // Allows text to take up available space
      maxWidth: "calc(100% - 40px)", // Allows for the icon space on the left
      overflow: "hidden", // Ensures text doesn't overflow beyond container
      textOverflow: "ellipsis", // Truncates text with ellipsis when too long
      whiteSpace: "nowrap", // Prevents text from wrapping to the next line
    },
    notificationBody: {
      color: "#201246",
      marginTop: "0.25rem",
      whiteSpace: "nowrap", // Prevent text from wrapping to the next line
      textOverflow: "ellipsis", // Truncates text with ellipsis if too long
      overflow: "hidden", // Hides excess content
      wordBreak: "break-word", // Breaks long words to avoid overflow
      fontSize: "12px", // Controls font size for better readability
      maxWidth: "200px", // Set a maximum width based on the character limit
    },
    emailDropdown: {
      color: "rgba(187, 200, 8, 1)",
      position: "absolute",
      backgroundColor: "white",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      padding: "1rem",
      top: "30px",
      left: 0,
      zIndex: "1000",
      width: "250px",
    },
    icon: {
      width: "21px",
      height: "21px",
      marginRight: "1rem",
      position: "relative",
      cursor: "pointer",
    },
  }));
  

const NotificationDropdown = ({ notifIcon, emailIcon, logoutIcon }) => {
  const [openNotif, setOpenNotif] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [activeTab, setActiveTab] = useState("Tout");
  const [selectedNotif, setSelectedNotif] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const userId = localStorage.getItem("userId");
  const [opene, setOpene] = useState(false);

  const handleClickOpen = () => {
    setOpene(true);
  };
  const navigate = useNavigate();

  const handleClose = () => {
    setOpene(false);
  };
  const disconnect = () => {
    localStorage.clear();
    dispatch(logoutUser());
    navigate("/login");
  };
  const classes = useStyles();

  useEffect(() => {
    const fetchNotifications = async () => {
      subscribeToNotifications(userId, (newNotifications) => {
        setNotifications(newNotifications);
      });
    };
    fetchNotifications();
  }, [userId]);
  const dispatch = useDispatch();

  const timeAgo = (timestamp) => {
    const now = new Date();
    const diffInSeconds = Math.floor((now - new Date(timestamp)) / 1000);
    const minutes = Math.floor(diffInSeconds / 60);
    const hours = Math.floor(diffInSeconds / 3600);
    const days = Math.floor(diffInSeconds / 86400);

    if (days > 1) return `Il y a ${days} jours`;
    if (days === 1) return `Il y a 1 jour`;
    if (hours > 1) return `Il y a ${hours} heures`;
    if (hours === 1) return `Il y a 1 heure`;
    if (minutes > 1) return `Il y a ${minutes} minutes`;
    if (minutes === 1) return `Il y a 1 minute`;
    return `Maintenant`;
  };

  const handleClickDropdown = (type) => () => {
    if (type === "notif") {
      setOpenEmail(false);
      setOpenNotif(!openNotif);
    } else {
      setOpenNotif(false);
      setOpenEmail(!openEmail);
    }
  };

  const handleNotificationClick = async (notif) => {
    const updatedNotifications = notifications.map((n) =>
      n.id === notif.id ? { ...n, read: true } : n
    );
    setNotifications(updatedNotifications);
    if (!notif.read) {
      await markNotificationAsRead(userId, notif);
    }

    setSelectedNotif(notif);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setSelectedNotif(null);
  };

  const filteredNotifications =
    activeTab === "Non Lus"
      ? notifications.filter((notif) => !notif.read)
      : notifications;

  const handleConfirmLogout = () => {
    handleClose();
    disconnect();
  };
  return (
    <>
      <span style={{ position: "relative" }}>
        <img
          src={notifIcon}
          alt="notif"
          className={classes.icon}
          onClick={handleClickDropdown("notif")}
        />
        {notifications.length > 0 && (
          <span
            className={classes.notificationBadge}
            onClick={handleClickDropdown("notif")}
          >
            {notifications.filter((notif) => !notif.read).length === 0
              ? ""
              : notifications.filter((notif) => !notif.read).length}
          </span>
        )}
        {openNotif && (
          <div className={classes.dropdown}>
            <h2
              style={{
                margin: "0 0 0.5rem",
                fontFamily: "Poppins",
                fontSize: "16px",
                fontWeight: 600,
                color: "rgba(187, 200, 8, 1)",
              }}
            >
              Notifications
            </h2>
            <div style={{ display: "flex", marginBottom: "1rem" }}>
              <button
                onClick={() => setActiveTab("Tout")}
                className={classes.dropdownButton}
                style={{
                  background:
                    activeTab === "Tout"
                      ? "rgba(240, 243, 199, 1)"
                      : "transparent",
                  color:
                    activeTab === "Tout"
                      ? "rgba(187, 200, 8, 1)"
                      : "rgba(60, 60, 60, 1)",
                }}
              >
                Tout
              </button>
              <button
                onClick={() => setActiveTab("Non Lus")}
                className={classes.dropdownButton}
                style={{
                  background:
                    activeTab === "Non Lus"
                      ? "rgba(240, 243, 199, 1)"
                      : "transparent",
                  color:
                    activeTab === "Non Lus"
                      ? "rgba(187, 200, 8, 1)"
                      : "rgba(60, 60, 60, 1)",
                }}
              >
                Non Lus
              </button>
            </div>
            <ul
              style={{
                listStyleType: "none",
                padding: 0,
                margin: 0,
                scrollbarWidth: "thin",
                scrollbarColor: "rgba(168, 168, 168, 1) transparent",
              }}
            >
              <style>
                {`
    .${classes.dropdown}::-webkit-scrollbar {
      width: 8px;
      height: 10px;
    }
    .${classes.dropdown}::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background: #c2c9d2;
    }
  `}
              </style>
              {filteredNotifications.length > 0 ? (
                filteredNotifications
                  .sort((a, b) => b.timestamp - a.timestamp)
                  .map((notif, index) => (
                    <li
                      key={index}
                      className={classes.notificationItem}
                      onClick={() => handleNotificationClick(notif)}
                    >
                      <img
                        src={
                          notif.read ? notificationReadIcon : notificationIcon
                        }
                        alt="notification-status"
                        style={{
                          width: "24px",
                          height: "24px",
                        }}
                      />
                      <div className={classes.notificationText}>
                        <strong style={{ color: "#3C6556" }}>
                          {notif.title}
                        </strong>
                        <small style={{ color: "#201246" }}>
                          {timeAgo(notif.timestamp)}
                        </small>
                        <p
                          className={classes.notificationBody}
                          style={{ margin: "0.25rem 0" }}
                        >
                          {notif.body}
                        </p>
                      </div>
                      {!notif.read && (
                        <span
                          style={{
                            position: "absolute",
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor: "green",
                            top: "50%",
                            right: "10px",
                            transform: "translateY(-50%)",
                          }}
                        />
                      )}
                    </li>
                  ))
              ) : (
                <p style={{ textAlign: "center", color: "gray" }}>
                  Aucune notification{" "}
                  {activeTab === "Non Lus" ? "non lu" : "disponible"}.
                </p>
              )}
            </ul>
          </div>
        )}
        <img src={emailIcon} alt="email" className={classes.icon} />
        <img
          src={logoutIcon}
          alt="logout"
          className={classes.icon}
          onClick={handleClickOpen}
        />
      </span>

      {selectedNotif && (
  <Dialog open={openModal} onClose={closeModal} fullWidth>
    {/* Image centered above the title */}
    <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
      <img src={star} alt="star" style={{ height: 50 }} />
    </div>

    <DialogTitle className="dialogTitle" style={{ paddingBottom: 0 }}>
      <span style={{ fontWeight: 600 }}>{selectedNotif.title}</span>
      <IconButton
        edge="end"
        color="inherit"
        onClick={closeModal}
        aria-label="close"
        style={{ position: "absolute", right: 15, top: 5 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>

    <DialogContent
      style={{
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
        justifyContent: "center",
        paddingTop: "0.5rem", // Reduced padding between title and content
        paddingBottom: "1rem", // Optional: adjust bottom padding as needed
      }}
    >
      <div
        style={{
          width: "100%",
          fontFamily: "Poppins",
          fontSize: 15,
          padding: "1rem",
        }}
      >
        <p>{selectedNotif.body}</p>
      </div>

      {/* Time Ago on the Right */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end", // Align to the right
          width: "100%",
        }}
      >
        <div
          style={{
            width: "fit-content",
            height: "26px",
            borderRadius: "51px",
            background: "rgba(240, 243, 199, 1)",
            textAlign: "center",
            padding: "5px",
            fontFamily: "Poppins",
            fontSize: "10.17px",
            fontWeight: 500,
            lineHeight: "15.26px",
            color: "rgba(187, 200, 8, 1)",
          }}
        >
          <small>{timeAgo(selectedNotif.timestamp)}</small>
        </div>
      </div>
    </DialogContent>
  </Dialog>
)}



      <Dialog open={opene} onClose={handleClose}>
        <DialogTitle
          style={{
            fontFamily: "Poppins",
            fontWeight: 600,
          }}
        >
          {"Se déconnecter?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            style={{
              fontFamily: "Poppins",
              fontSize: 15,
              fontWeight: 600,
            }}
          >
            {"Êtes-vous sûr de vouloir vous déconnecter?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            style={{
              width: "fit-content",
              height: "34px",
              borderRadius: "6px",
              background: "rgba(240, 243, 199, 1)",
              border: 0,
              fontFamily: "Poppins",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "18px",
              color: "rgba(60, 101, 86, 1)",
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleConfirmLogout}
            style={{
              width: "fit-content",
              height: "34px",
              borderRadius: "6px",
              background: "rgba(187, 200, 8, 1)",
              border: 0,
              fontFamily: "Poppins",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "18px",
              color: "rgba(255, 255, 255, 1)",
            }}
          >
            Déconnexion
          </Button>
        </DialogActions>
      </Dialog>
   
    </>
  );
};

export default NotificationDropdown;
